import {
  Directive, ComponentFactoryResolver, ViewContainerRef, Input, OnInit, OnChanges,
  SimpleChanges
} from '@angular/core';
import {IframePageComponent} from '../iframe-page/iframe-page.component';
import {TabsDinamicasComponent} from '../tabs-dinamicas/tabs-dinamicas.component';
import {AcoesComponent} from '../../acoes/acoes.component';
import {IframePageDiferentesComponent} from '../iframe-page-diferentes/iframe-page-diferentes.component';
import {FormularioDinamicoComponent} from '../formulario-dinamico/formulario-dinamico.component';
import {FormularioDinamico2Component} from '../formulario-dinamico2/formulario-dinamico2.component';

const components = {
  iframe: IframePageComponent,
  iframeDiferente: IframePageDiferentesComponent,
  formulario: FormularioDinamicoComponent,
  formulario2: FormularioDinamico2Component,
  tabs: TabsDinamicasComponent,
  acoes: AcoesComponent
};

@Directive({
  selector: '[appComponenteDinamico]'
})

export class ComponenteDinamicoDirective implements OnInit, OnChanges {
  @Input() config;

  component;

  constructor(private resolver: ComponentFactoryResolver, private container: ViewContainerRef) {
  }

  buildComponent() {
    const component = components[this.config.type];
    const factory = this.resolver.resolveComponentFactory<any>(component);
    this.component = this.container.createComponent(factory);
    this.component.instance.data = this.config.options;
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.config && changes.config.currentValue) {
      this.buildComponent();
    }
  }
}
